import React, { forwardRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {  Dialog, IconButton, Typography } from '@material-ui/core';
import DialogContent from '@material-ui/core/DialogContent';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Slide from '@material-ui/core/Slide';
import { WindowSize } from '../../common/constants';
import Colours from '../../common/colours';
import layoutAction from '../../actions/layout';
import Icons from './Icons';

const Transition = forwardRef((props, ref) => <Slide direction="left" ref={ref} {...props} />);

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiBackdrop-root': {
      display: 'none',
    },
  },
}));

const SlidingPanel = (props) => {
  const classes = useStyles();
  useEffect(() => {
    if (props.slidingPanel.open) {
      window.addEventListener('keyup', (e) => {
        if (e.which === 27) {
          props.slidingPanel.onClose();
        }
      });
    } else {
      window.removeEventListener('keyup', this);
    }
  }, [props.slidingPanel]);

  const close = () => {
    props.dispatchCloseSlidingPanel();
  };

  return (
    <Dialog
      className={classes.root}
      open={props.slidingPanel.open}
      TransitionComponent={Transition}
      keepMounted
      fullScreen
      style={{ marginLeft: props.windowSize === WindowSize.Mobile ? 0 : '20vw', marginTop: 0, zIndex: 5 }}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogContent style={{
        height:  '100vh',
        padding: '40px 40px',
      }}
      >
        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          <Typography variant="h5">{props.slidingPanel.title}</Typography>
          <IconButton onClick={close} style={{ marginLeft: 'auto' }}>
            <Icons.Cross color={Colours.Black} fontSize={props.windowSize === WindowSize.Mobile ? '20px' : '41px'} />
          </IconButton>
        </div>
        {props.slidingPanel.content}
      </DialogContent>
    </Dialog>
  );
};

SlidingPanel.propTypes = {
  windowSize:   PropTypes.string.isRequired,
  showBackBtn:  PropTypes.bool,
  slidingPanel: PropTypes.shape({
    open:    PropTypes.bool,
    onClose: PropTypes.shape({
      text:   PropTypes.string,
      action: PropTypes.func,
    }),
    title:     PropTypes.string,
    onConfirm: PropTypes.shape({
      text:   PropTypes.string,
      action: PropTypes.func,
    }),
    content: PropTypes.node,
  }).isRequired,
};

SlidingPanel.defaultProps = {
  showBackBtn: false,
};

const mapStateToProps = (state) => ({
  windowSize:   state.layout.windowSize,
  slidingPanel: state.layout.slidingPanel,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchCloseSlidingPanel: () => layoutAction.slidingPanel(dispatch, { open: false }),
});

export default connect(mapStateToProps, mapDispatchToProps)(SlidingPanel);
